// PermissionService.js

import axios from 'axios';
import { URL } from "../config";
const BASE_URL = URL;

const permissionService = {
  getAllPermissions: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/permissions`);
      const payload = response.data?.data ?? response.data;
      if (!Array.isArray(payload)) {
        throw new Error('empty response');
      }
      return payload;
    } catch (error) {
      // console.error('Error fetching permissions:', error);
      throw new Error(`Error fetching permissions: ${error.message}`);
    }
  },

  getPermissionById: async (permissionId) => {
    try {
      const response = await axios.get(`${BASE_URL}/permissions/${permissionId}`);
      return response.data.data || response.data;
    } catch (error) {
      throw new Error(`Error fetching permission: ${error.message}`);
    }
  },

  updatePermissionTargets: async (permissionId, targets) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/permissions/${permissionId}/targets`,
        targets
      );
      return response.data.data || response.data;
    } catch (error) {
      throw new Error(`Error updating permission: ${error.message}`);
    }
  },

  createPermission: async (permissionData) => {
    try {
      const response = await axios.post(`${BASE_URL}/api/permissions`, permissionData);
      return response.data.data || response.data;
    } catch (error) {
      throw new Error(`Error creating permission: ${error.message}`);
    }
  },
};

export default permissionService;
